import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function safeParseFloat(value) {
  if (value == null) return 0;
  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
}
const generateExcelFile = async (dataArray) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("AIR TICKETS");

  // Headers
  const headers = [
    "INVOICE NO",
    "BOOKING DATE",
    "SUPPLIER",
    "GDS LOCATOR",
    "COST OF",
    "SOLD FARE",
    "TICKET NO",
    "CUSTOMER NAME",
    "AIRLINE",
    "STATUS",
    "MODE OF PAYMENT PAX",
    "MODE OF PAYMENT SUPPLIER",
    "REFERENCE NUMBER OF ET",
    "SALES AGENT",
    "SPECIAL REMARKS",
  ];

  // Add header row
  worksheet.addRow(headers);

  // Add data rows
  dataArray.forEach((data) => {
    // supplier cost
    const supplierTotal = safeParseFloat(
      data?.airticket?.airticket_to_supplier?.total
    );
    const supplierRefund = safeParseFloat(
      data?.airticket?.airticket_to_supplier?.refund
    );
    const costOf =
      safeParseFloat(supplierTotal) - safeParseFloat(supplierRefund);
    // sale to client
    const soldFare =
      safeParseFloat(data?.airticket?.airticket_from_pax?.total || 0) -
      safeParseFloat(data?.airticket?.airticket_from_pax?.refund || 0);
    worksheet.addRow([
      data?.invoice_number || "N/A",
      data?.booking_date || "N/A",
      data?.supplier?.name || "N/A",
      data?.gds_locator || "N/A",
      costOf || "N/A",
      soldFare || "N/A",
      data?.ticket_number || "N/A",
      data?.customer_details?.full_name || "N/A",
      data?.airLine?.airline_name || "N/A",
      data?.status || "N/A",
      data?.airticket?.airticket_from_pax?.transaction_type_name || "N/A",
      data?.airticket?.airticket_to_supplier?.transaction_type_name || "N/A",
      data?.reference_no_et || "N/A",
      data?.sales_agents?.name || "N/A",
      data?.other_remarks || "N/A",
    ]);
  });

  // Freeze header row
  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  // Apply auto-filter
  worksheet.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: headers.length },
  };

  // Column widths based on header length
  worksheet.columns = headers.map((header) => ({
    width: Math.min(Math.max(header.length + 10, 18), 60),
  }));

  // Enhanced styling
  worksheet.eachRow((row, rowNumber) => {
    row.height = 28; // more vertical spacing

    row.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        horizontal: rowNumber === 1 ? "center" : "left",
        wrapText: true,
      };

      cell.font = {
        name: "Calibri",
        size: rowNumber === 1 ? 13 : 12,
        bold: rowNumber === 1,
        color: { argb: rowNumber === 1 ? "FFFFFF" : "000000" },
      };

      cell.border = {
        top: { style: "thin", color: { argb: "BFBFBF" } },
        bottom: { style: "thin", color: { argb: "BFBFBF" } },
        left: { style: "thin", color: { argb: "BFBFBF" } },
        right: { style: "thin", color: { argb: "BFBFBF" } },
      };

      // Header fill - ORANGE
      if (rowNumber === 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F57C00" }, // deep orange
        };
      } else {
        // Zebra striping for rows
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: rowNumber % 2 === 0 ? "FFF3E0" : "FFFFFF" }, // light orange tint
        };
      }
    });
  });

  // Generate and save file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const fileName = dataArray[0]?.invoice_number
    ? `AIR_TICKETS_${dataArray[0].invoice_number}_TO_${
        dataArray[dataArray.length - 1].invoice_number
      }.xlsx`
    : `AIR_TICKETS_${new Date().toISOString().slice(0, 10)}.xlsx`;

  saveAs(blob, fileName);
};

export default generateExcelFile;
